export default "__VITE_ASSET__Dor6wcuv__"